module.exports = { raw: '9.6.1' };



//////////////////
// WEBPACK FOOTER
// ./~/auth0-js/src/version.js
// module id = 54
// module chunks = 0